
/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { Fragment, useState, useEffect } from 'react';
import FeeStructureDropdown from '../../../../components/FeeStructureDropdown';
import { ShimmerTitle } from 'react-shimmer-effects';
import moment from 'moment';

export default function FeeStructureDetails({
    academicYears,
    classes,
    sections,
    selectedAcademicYear,
    selectedClass,
    selectedSection,
    handleOnchangeInput,
    feeStructure,
    feeStructureLoading,
    sectionLoading,
    submitSelected,
    feeTerm,
    selectedDropDownValue,
    selectedFeeTermData,
    academicYearLoading,
    classLoading,
})  {
    return (
        <div className="mx-auto mt-4 pb-[130px]">
            <div className="border border-[#D0D5DD] p-3 rounded w-[100%]" >
                <div className="flex justify-between ">
                    <div className="w-[50%]">
                        <div className="flex pb-3">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Academic Year<span class="req-fld-astrk">*</span></p>
                            <FeeStructureDropdown
                                dropDownName={"academic_year"}
                                id={"academic_year"}
                                test_id={"year_name"}
                                value={selectedAcademicYear === "" ? "" : `${selectedAcademicYear?.name}`}
                                placeHolder={"Select Academic Year"}
                                showErrorBorder={submitSelected && selectedAcademicYear === ""}
                                applyBGForDisabled={true}
                                isMandatoryField={true}
                                options={academicYears}
                                loading={academicYearLoading}
                                handleOnchangeInput={handleOnchangeInput} />
                        </div>
                        <div className="flex pb-3">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Class<span class="req-fld-astrk">*</span></p>
                            <FeeStructureDropdown
                                dropDownName={"class"}
                                id={"class"}
                                test_id={"class_name"}
                                value={selectedClass === "" ? "" : `${selectedClass?.name}`}
                                placeHolder={"Select Class"}
                                showErrorBorder={submitSelected && selectedClass === ""}
                                applyBGForDisabled={true}
                                isMandatoryField={true}
                                options={classes}
                                loading={classLoading}
                                handleOnchangeInput={handleOnchangeInput} />
                            {/* <p className="text-f7 font-semibold text-[#031624] min-w-[138px] inline-flex">{studentDetails.classes.class_name}</p> */}
                        </div>
                        <div className="flex">
                            <p className="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Section<span class="req-fld-astrk">*</span></p>
                            <FeeStructureDropdown
                                dropDownName={"section"}
                                id={"section"}
                                test_id={"section_name"}
                                value={selectedSection === "" ? "" : `${selectedSection?.name}`}
                                buttonDisabled={selectedAcademicYear?.name === "" || selectedClass?.name === ""}
                                placeHolder={"Select Section"}
                                showErrorBorder={submitSelected && selectedSection === ""}
                                applyBGForDisabled={true}
                                isMandatoryField={true}
                                options={sections}
                                loading={sectionLoading}
                                handleOnchangeInput={handleOnchangeInput} />
                        </div>
                    </div>
                    {
                        feeStructureLoading ? (
                            // Shimmer if the API is still loading
                            <div className="w-[50%] ml-8">
                                <p className="font-semibold">Fee Structure</p>
                                <div className="flex flex-col justify-between border border-[#D0D5DD] p-2 mt-2 rounded">
                                    <div className="px-2" style={{ 'height': '87px' }}>
                                        <p className="text-2xl font-bold text-[#031624] mt-4">
                                            <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]" />
                                        </p>
                                        <p className="text-2xl font-bold text-[#031624]">
                                            <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]" />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // Case 1: didAcademicDropDownChange is true
                            feeStructure?.length !== 0 ? (
                                // Case 1.1: feeStructure is not empty, map feeStructure
                                <div className="w-[50%] ml-8">
                                    <p className="pb-2 font-semibold">Fee Structure</p>
                                    <div className="flex flex-col justify-between border border-[#D0D5DD] p-1 rounded">
                                        <div className="h-[100px] overflow-y-auto scroll-bar px-2">
                                            {feeStructure[0]?.fees?.map((fee) => (
                                                <div key={fee?.fee_head_id} className="flex">
                                                    <p className="text-f7 py-1 font-normal text-[#031624] w-1/2 inline-flex">
                                                        {fee?.fee_head}
                                                    </p>
                                                    <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                        {parseFloat(fee?.amount).toFixed(2)}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                        <hr />
                                        <div className="flex pt-[10px] px-2">
                                            <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Academic Fee</p>
                                            <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                                {parseFloat(feeStructure[0]?.cumulative_amount).toFixed(2)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                //case 1.2: if AY, class is not selected
                                selectedAcademicYear === "" || selectedClass === "" ? (
                                    <div className="w-[50%] ml-8">
                                        <p className="pb-2 font-semibold">Fee Structure</p>
                                        <div className="flex justify-center items-center border border-[#D0D5DD] p-6 my-2 rounded" style={{ 'height': '105px' }}>
                                            <p>Please select Academic Year and Class to view the fee structure</p>
                                        </div>
                                    </div>
                                ) : (
                                    // Case 1.3: feeStructure is empty
                                    <div className="w-[50%] ml-8">
                                        <p className="pb-2 font-semibold">Fee Structure</p>
                                        <div className="flex justify-center items-center border border-[#D0D5DD] p-6 rounded" style={{ height: '105px' }}>
                                            <p>
                                                No Fee Structure found for the selected AY and class. Click&nbsp;
                                                <button
                                                    type="button"
                                                    onClick={() => window.open(`/fee-management/fee-structure/add-fee-structure`, '_blank', 'noopener,noreferrer')}
                                                    className="text-[#0066CC] underline cursor-pointer bg-transparent p-0"
                                                >
                                                    here
                                                </button>
                                                &nbsp;to add one.
                                            </p>
                                        </div>
                                    </div>
                                )
                            )
                        )
                    }
                </div>
            </div>
            <div className="border border-[#D0D5DD] rounded mt-6 mb-3 mx-auto">
                <div className="flex items-center bg-[#EEF7FE] py-2 w-full rounded">
                    <label className="text-f2 px-4 font-normal text-[#031624] min-w-[118px] inline-flex">Select Fee Term</label>
                    <div className="relative w-[25%] 2xl:w-[20%]">
                        <FeeStructureDropdown
                            dropDownName={"fee-term-dropdown"}
                            id={"fee-term-dropdown"}
                            test_id={"fee-term-dropdown"}
                            value={selectedDropDownValue === "" ? "Select Fee Term" : `${selectedDropDownValue}`}
                            placeHolder={"Select Fee Term"}
                            showErrorBorder={submitSelected && feeStructure.length > 0 && selectedDropDownValue === ""}
                            buttonDisabled={selectedAcademicYear === "" || selectedClass === "" || feeStructure.length === 0}
                            applyBGForDisabled={true}
                            isMandatoryField={true}
                            options={feeTerm}
                            handleOnchangeInput={handleOnchangeInput} />
                    </div>
                </div>
                <div className="px-4 mt-4">

                    {!selectedDropDownValue && (
                        <div className="flex justify-evenly">
                            <p className="p-8 mb-8 min-h-[200px] text-center">
                                Select a Fee Term to view the breakdown of Fee Structure
                            </p>
                        </div>
                    )}


                    {selectedDropDownValue && (
                        <div className={`flex flex-wrap -mx-2`}>

                            <div className="px-2 w-[100%]">
                                {!selectedDropDownValue ? (
                                    <div className="flex justify-evenly">
                                        <p className="p-8 mb-8 min-h-[200px] text-center">
                                            Select a Fee Term to view the breakdown of Fee Structure
                                        </p>
                                    </div>
                                ) : (
                                    <div className="flex flex-wrap -mx-2">
                                        {selectedFeeTermData?.terms?.length === 0 ? (<div className="flex justify-center items-center w-full">
                                            <p className="p-8 mb-8 min-h-[200px] text-center">No Terms available</p>
                                        </div>
                                        ) : (
                                            selectedFeeTermData?.terms?.map((term, originalIndex) => {
                                                const isFutureTerm = moment(term?.end_date.split("T")[0]).isSameOrAfter(moment());
                                                const endDate = moment(term?.end_date?.split("T")[0]);
                                                const startDate = moment(term?.start_date?.split("T")[0]);
                                                const terms = selectedFeeTermData?.terms;

                                                return (
                                                    <div className="w-[50%] px-2" key={originalIndex}>
                                                        <div className="flex flex-col justify-between overflow-y-auto scroll-bar border border-[#D0D5DD] p-2 mb-3 rounded w-full relative">
                                                            <div>
                                                                {!isFutureTerm && (
                                                                    <p className="custom-label">
                                                                        Past Term – Not Billable
                                                                    </p>
                                                                )}
                                                                <p className="font-semibold px-2">
                                                                    {term?.term_name} (
                                                                    {startDate.format("MMM DD, YYYY")} - {endDate.format("MMM DD, YYYY")})
                                                                </p>

                                                                <div className="h-[100px] overflow-y-auto scroll-bar p-2">
                                                                    {terms?.[originalIndex]?.fee_head?.map((fee) => (
                                                                        <div key={fee?.fee_head_id} className="flex">
                                                                            <p className="text-f7 py-1 font-normal text-[#171a1d] w-1/2 inline-flex">
                                                                                {fee?.fee_head_name}
                                                                            </p>
                                                                            <p className="text-f7 py-1 text-end font-normal text-[#031624] w-1/2">
                                                                                {parseFloat(fee?.fee_head_amount).toFixed(2) || "-"}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <hr />
                                                            </div>
                                                            <div className="flex justify-items-end pt-[5px] px-2">
                                                                <p className="text-f7 font-normal text-[#031624] w-1/2 inline-flex">Term Fee</p>
                                                                <p className="text-f7 text-end font-semibold text-[#031624] w-1/2">
                                                                    {parseFloat(term?.term_amount).toFixed(2) || "-"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};